module.exports = __webpack_public_path__ + "img/suha-logo-green.83270532.png";